import { getApp } from '@genesislcap/foundation-shell/app';
import { css } from '@genesislcap/web-core';
import { stylesFontFaces } from '../../mbm/styles';
import './main.css';

export const MainStyles = css`

  foundation-auth:defined {
      visibility: visible;
  }
    
  ${stylesFontFaces}
  :host {
    contain: content;
    --nav-height: 48px;
    --black-color: #1c2024;
  }

  :host,
  rapid-design-system-provider,
  .dynamic-template,
  foundation-router {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: var(--neutral-layer-4);
    --accent-fill-rest-30: color-mix(in srgb, var(--accent-fill-rest) 30%, transparent);
  }

  fast-progress {
    --accent-foreground-rest: #654df9;
    height: calc(var(--design-unit) * 1px);
    margin: 0;
    width: 100%;
  }
}
`.withBehaviors(getApp().registerStylesTarget('main'));
